import { jsx } from '@amazon/vinyl-tsx'
import type { ObservableValue } from '@amazon/vinyl-observable'

/** Shows `src` in `host`; if it fails to load, `host` goes back to `placeholder` (or empty). */
export function showArt(host: HTMLElement, src: string, placeholder?: () => Node): void {
    const img = (<img src={src} alt="" />) as HTMLImageElement
    img.addEventListener(
        'error',
        () => {
            if (img.parentNode !== host) return
            if (placeholder) host.replaceChildren(placeholder())
            else host.replaceChildren()
        },
        { once: true }
    )
    host.replaceChildren(img)
}

/**
 * Hands `apply` each url, then null if that url fails to load, so a background-image avatar can
 * fall back to its placeholder. Returns the unsubscribe.
 */
export function watchLoadableUrl(
    url$: ObservableValue<string | null>,
    apply: (url: string | null) => void
): () => void {
    let current: string | null = null
    const stop = url$.onData((url) => {
        current = url
        apply(url)
        if (!url) return
        const probe = document.createElement('img')
        probe.addEventListener(
            'error',
            () => {
                if (current === url) apply(null)
            },
            { once: true }
        )
        probe.src = url
    })
    return () => {
        current = null
        stop()
    }
}
